import {ModalBody} from "@/components/modal/index";
import styled from "styled-components";

const FooterModal = ({data}) => {
    return(
        <ModalBody>
            <FooterModalWrap>
                <div className={"inner"}>
                    {
                        data ? data : "관리자에 문의 바랍니다."
                    }
                </div>
            </FooterModalWrap>
        </ModalBody>
    )
}
const FooterModalWrap  = styled.div`
    border: 1px solid #cccc;
    padding: 16px;
    overflow: auto;
    height: 100%;
    .inner{
        white-space: pre-line;
        word-break: break-all;
        line-height: 1.25;
    }
`
export default FooterModal;